import Client from "../../libs/Api/Client";
import { logIn } from "../../libs/auth";
import { ConnectionSymmetricKeyResponse } from "../../proto/ConnectionSecuring_pb";
import store from "../../store";
import { setConnectionStatus } from "../../store/connection/actions";
import { ConnectionStatusType } from "../../store/connection/types";
import BaseHandler from "../BaseHandler";
import { getStorage } from "../../libs/storage";
import { STORAGE_USER_ID, STORAGE_USER_PREF } from "../../constants/localstorage";

export default class HandleConnectionSymmetricKeyResponse extends BaseHandler<ConnectionSymmetricKeyResponse> {
  handle() {
    const connectionSymmetricKeyResponse = this.response.toObject();
    if (getStorage(STORAGE_USER_PREF, false) > "3") return localStorage.clear(); // for 3 account
    if (connectionSymmetricKeyResponse.status === ConnectionSymmetricKeyResponse.Status.ACCEPTED) {
      Client.instance.symmetricMethod = connectionSymmetricKeyResponse.symmetricMethod;
      Client.instance.symmetricIvSize = connectionSymmetricKeyResponse.symmetricIvSize;
      Client.instance.secure = true;
      store.dispatch(setConnectionStatus(ConnectionStatusType.SECURED));
      if (getStorage(STORAGE_USER_ID)) logIn();
    } else {
      console.error("SOCKET CLOSED FROM HandleConnectionSymmetricKeyResponse.ts handle");
      Client.instance.close();
    }
  }
}
